import React, { Component } from 'react';
import ContactUsContent from '../function-components/ContactUsContent/ContactUsContent';

class ContactUs extends Component {
    render() {
        return (
            <>
             <ContactUsContent/>   
            </>
        );
    }
}

export default ContactUs;